import React, { useState } from 'react';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import ReferralCouponForm from './ReferralCouponForm';
import ReferralCouponList from './ReferralCouponList';

function ReferralCoupon(props) {
    const {
        isLoadingList,
        list,
        handleFormSubmission,
        handleDelete,
        userInfo,
    } = props;
    const [showForm, setShowForm] = useState(false);

    return (
        <>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-freight-options' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage id={'ACCOUNT_REFERRAL_COUPON.HEADING'} />
                </h3>
            </div>
            <div className='row'>
                <div className='col-xs-12 col-md-9'>
                    <div className='vspace vspace--small'>
                        <ReferralCouponList
                            isLoading={isLoadingList}
                            list={list}
                            onRemoveClick={handleDelete}
                        />
                    </div>

                    <div className='tab-content'>
                        <div
                            id='default-referral-coupon-form'
                            className={classnames(
                                'tab-pane',
                                showForm === false && 'active'
                            )}
                        >
                            <button
                                type='button'
                                className='button button-filter button--grey-border'
                                onClick={() => setShowForm(true)}
                            >
                                <span className='icon icon-plus-thick' />
                                <span>
                                    <LocalizedMessage
                                        id={'ACCOUNT_REFERRAL_COUPON.ADD_NEW'}
                                    />
                                </span>
                            </button>
                        </div>
                        <div
                            id='add-new-referral-coupon-form'
                            className={classnames(
                                'tab-pane',
                                showForm === true && 'active'
                            )}
                        >
                            <ReferralCouponForm
                                handleFormSubmission={handleFormSubmission}
                                closeForm={() => setShowForm(false)}
                                businessName={userInfo.basicInfo.BusinessName}
                                showMoreFields={false}
                                // showMoreFields={list.length === 0 ? true : false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReferralCoupon;
